import { c as _c } from "react/compiler-runtime";
import { FieldsEditType } from '@systemeio/digital-store-shared';
import { BUTTON_BASE_CLASS_NAME as BASE_CLASS_NAME, BUTTON_BASE_FLEX_CLASS_NAME as BASE_FLEX_CLASS_NAME, ContactFiledInterface, FormSelectDataType, getContactFieldTitle, ListBoxSelect, useTranslation as useUiTranslation } from '@systemeio/ui';
import React, { FC } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { AddIcon } from '@systemeio/ui/icons';
interface StoreAddFieldProps {
  fields?: ContactFiledInterface[];
  onAdd: (field: FieldsEditType) => void;
}
const StoreAddField: FC<StoreAddFieldProps> = t0 => {
  const $ = _c(15);
  const {
    fields,
    onAdd
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  let t1;
  if ($[0] !== fields || $[1] !== tUi) {
    t1 = fields?.map(f => ({
      id: f.slug,
      caption: getContactFieldTitle(f, tUi)
    }));
    $[0] = fields;
    $[1] = tUi;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const data = t1;
  const disabled = fields?.length === 0;
  let t2;
  if ($[3] !== fields || $[4] !== onAdd || $[5] !== tUi) {
    t2 = data_0 => {
      if (!data_0) {
        return;
      }
      const field = fields?.find(f_0 => f_0.slug === data_0);
      if (field) {
        onAdd({
          fieldName: getContactFieldTitle(field, tUi),
          slug: field.slug,
          required: false
        });
      }
    };
    $[3] = fields;
    $[4] = onAdd;
    $[5] = tUi;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== disabled || $[8] !== t) {
    t3 = () => <div className={twMerge(BASE_CLASS_NAME, BASE_FLEX_CLASS_NAME, "bg-brand-primary text-background-secondary hover:bg-brand-primary-hover px-4", disabled && "bg-text-secondary/50 hover:bg-text-secondary/50")}><AddIcon />{t("dashboard.store.item.add_field")}</div>;
    $[7] = disabled;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== data || $[11] !== disabled || $[12] !== t2 || $[13] !== t3) {
    t4 = <ListBoxSelect buttonClassName="w-fit self-center rounded-lg" value={undefined} data={data} disabled={disabled} onChange={t2}>{t3}</ListBoxSelect>;
    $[10] = data;
    $[11] = disabled;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default StoreAddField;